import React from 'react';
import { Box, Typography, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { BLOCK_COLORS, TETROMINOES } from '../../utils/tetris-utils';

const GameStats = ({ score, level, lines, nextPiece }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        p: 2,
        backgroundColor: theme.palette.background.paper,
        borderRadius: 2,
        border: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack spacing={2}>
        <StatItem label="Score" value={score.toLocaleString()} />
        <Stack direction="row" spacing={2}>
          <StatItem label="Level" value={level} />
          <StatItem label="Lines" value={lines} />
        </Stack>

        <Box>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ textTransform: 'uppercase', letterSpacing: 1 }}
          >
            Next
          </Typography>
          <Box sx={{ mt: 1 }}>
            {nextPiece ? (
              <NextPiecePreview piece={nextPiece} />
            ) : (
              <Box sx={{ height: 60 }} />
            )}
          </Box>
        </Box>

        <Box sx={{ pt: 1, borderTop: `1px solid ${theme.palette.divider}` }}>
          <Typography variant="caption" color="text.secondary">
            Controls
          </Typography>
          <Stack spacing={0.25} sx={{ mt: 0.5 }}>
            <ControlRow keys="← →" action="Move" />
            <ControlRow keys="↑" action="Rotate" />
            <ControlRow keys="↓" action="Soft drop" />
            <ControlRow keys="Space" action="Hard drop" />
            <ControlRow keys="P" action="Pause" />
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

const StatItem = ({ label, value }) => (
  <Box>
    <Typography
      variant="caption"
      color="text.secondary"
      sx={{ textTransform: 'uppercase', letterSpacing: 1 }}
    >
      {label}
    </Typography>
    <Typography variant="h5" fontWeight={700}>
      {value}
    </Typography>
  </Box>
);

const ControlRow = ({ keys, action }) => (
  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
    <Typography
      variant="caption"
      sx={{
        fontFamily: 'monospace',
        backgroundColor: 'action.hover',
        px: 0.5,
        borderRadius: 0.5,
      }}
    >
      {keys}
    </Typography>
    <Typography variant="caption" color="text.secondary">
      {action}
    </Typography>
  </Box>
);

const NextPiecePreview = ({ piece }) => {
  const colors = BLOCK_COLORS[piece.color];
  const shape = TETROMINOES[piece.type].shape[0];
  const size = 16;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
      {shape.map((row, y) => (
        <Box key={y} sx={{ display: 'flex', gap: '2px' }}>
          {row.map((cell, x) => (
            <Box
              key={x}
              sx={{
                width: size,
                height: size,
                backgroundColor: cell ? colors.fill : 'transparent',
                borderRadius: 0.5,
              }}
            />
          ))}
        </Box>
      ))}
      {piece.word && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
          {piece.word}
        </Typography>
      )}
    </Box>
  );
};

export default GameStats;
